import { createContext } from 'react'

export const CurrencyExchangeRateContext = createContext<
  Record<string, number>
>({})
